<template>
    <header class="header">
        <div class="header__inner">
            <h2>
                <template v-if="title">
                    <span>{{ title }}</span>
                </template>
                <template v-else>
                    대시보드
                </template>
            </h2>

            <div class="profile-box">
                <!-- 프로필 아이콘 클릭으로 드롭다운 토글 -->
                <div class="profile-avatar" @click="toggleDropdown">
                    <img src="@/assets/resource/icon/icon.png" alt="사용자 아이콘" />
                </div>

                <!-- 드롭다운 메뉴 -->
                <div v-show="dropdownOpen" class="dropdown-menu" ref="dropdownMenu">
                    <ul>
                        <li @click="logout">로그아웃</li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

export default {
    name: 'Header',
    props: {
        title: { type: String, required: true }
    },
    data() {
        return {
            dropdownOpen: false
        };
    },
    methods: {
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        logout() {
            localStorage.removeItem('jwtToken');
            this.$emit('logout');
            this.dropdownOpen = false;
        },
        handleClickOutside(event) {
            const dropdownMenu = this.$refs.dropdownMenu;
            const profileAvatar = this.$el.querySelector('.profile-avatar');
            if (
                this.dropdownOpen &&
                dropdownMenu &&
                !dropdownMenu.contains(event.target) &&
                !profileAvatar.contains(event.target)
            ) {
                this.dropdownOpen = false;
            }
        }
    },
    mounted() {
        document.addEventListener('mousedown', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
};
</script>
<style scoped>
.profile-avatar {cursor: pointer;display: flex;align-items: center;}
.profile-avatar img {width: 24px;height: 24px;}

.profile-box {position: relative;display: flex;align-items: center;}
.dropdown-menu {position: absolute;top: 40px;right: 0;border: 1px solid #ddd;border-radius: 4px;box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);width: 160px;z-index: 1000;background: #fff;}
.dropdown-menu ul {list-style: none;margin: 0;padding: 0;}
.dropdown-menu li {padding: 12px 16px;cursor: pointer;font-size: 14px;}
.dropdown-menu li:hover {background-color: #f5f5f5;}
</style>
